import { useMemo } from "react";

import { useAppSelector } from "hooks/store";
import { getUserState } from "store/slices/Auth/authSlice";
import { PermissionDisagreements, getUserPermissionDisagreement } from "utils/disagreementsUtils";

export function useGetDisagreementPermissions() {
  const userData = useAppSelector(getUserState);

  const permission: PermissionDisagreements = useMemo(() => getUserPermissionDisagreement(userData), [userData]);

  return permission;
}
